import React from 'react';
import { Box } from '@mui/material';

interface Props {
  color?: string;
  height?: number;
  opacity?: string;
  sx?: object;
  width?: number;
}

const CircleOneGraphic = ({
  color = '#f4ba41',
  height = 80,
  opacity = '.23',
  sx,
  width = 80,
}: Props) => (
  <Box sx={sx}>
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100.17 100.17"
      width={width}
      height={height}
    >
      <circle className="cls-2" cx="50.08" cy="50.08" r="50.08" fill={color} opacity={opacity} />
      <circle className="cls-1" cx="30.32" cy="35.39" r="39.86" fill="none" />
    </svg>
  </Box>
);

export default CircleOneGraphic;
